import { useEffect, useState } from "react";
import api from '../config/api';

export default function EditItemModal({ show, onClose, itemData, onSuccess }) {
  const [form, setForm] = useState({
    code: "",
    measurement_unit: "",
    stock: 0,
    description: "",
    created_by: 1,
    modified_by: 1,
  });

  const parseJwt = (token) => {
    try {
      const base64Url = token.split('.')[1];
      const base64 = base64Url.replace(/-/g, '+').replace(/_/g, '/');
      return JSON.parse(window.atob(base64));
    } catch (e) {
      return null;
    }
  };

  useEffect(() => {
    if (itemData) {
      setForm({
        code: itemData.code || "",
        measurement_unit: itemData.measurement_unit || "",
        stock: itemData.stock || 0,
        description: itemData.description || "",
        created_by: itemData.created_by || 1,
        modified_by: itemData.modified_by || 1,
        id: itemData.id, // penting untuk ke endpoint PUT
      });
    }
  }, [itemData]);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setForm((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    const token = localStorage.getItem("token");
    const user = parseJwt(token);

    const payload = {
      code: form.code,
      measurement_unit: form.measurement_unit,
      description: form.description,
      created_by: form.created_by,
      modified_by: user?.user_id,
    };

    try {
      const res = await fetch(api(`/items/${form.id}`), {
        method: "PUT",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
        body: JSON.stringify(payload),
      });

      if (!res.ok) {
        alert("Failed to update item.");
        return;
      }

      alert("Item updated successfully!");
      onClose();
      onSuccess();
    } catch (err) {
      console.error("Update error:", err);
      alert("Something went wrong.");
    }
  };

  if (!show || !itemData) return null;

  return (
    <div className="modal fade-modal show d-block" style={{ background: "rgba(0,0,0,0.5)" }}>
      <div className="modal-dialog modal-md">
        <div className="modal-content">
          <form onSubmit={handleSubmit}>
            <div className="modal-header">
              <h5 className="modal-title">Edit Item</h5>
              <button type="button" className="btn-close" onClick={onClose}></button>
            </div>
            <div className="modal-body">
              <div className="mb-3">
                <label className="form-label">Item Code</label>
                <input
                  type="text"
                  className="form-control"
                  name="code"
                  value={form.code}
                  onChange={handleChange}
                  required
                />
              </div>
              <div className="mb-3">
                <label className="form-label">Measurement Unit</label>
                <input
                  type="text"
                  className="form-control"
                  name="measurement_unit"
                  value={form.measurement_unit}
                  onChange={handleChange}
                  required
                />
              </div>
              <div className="mb-3">
                <label className="form-label">Stock (not editable)</label>
                <input
                  type="number"
                  className="form-control"
                  name="stock"
                  value={form.stock}
                  disabled
                />
              </div>
              <div className="mb-3">
                <label className="form-label">Description</label>
                <textarea
                  className="form-control"
                  name="description"
                  rows="2"
                  value={form.description}
                  onChange={handleChange}
                />
              </div>
            </div>
            <div className="modal-footer">
              <button className="btn btn-secondary" type="button" onClick={onClose}>
                Cancel
              </button>
              <button className="btn btn-primary" type="submit">
                Save Changes
              </button>
            </div>
          </form>
        </div>
      </div>
    </div>
  );
}
